import { countryFilterBy } from './country';

export const allFilterBys = [countryFilterBy];
